import { render, staticRenderFns } from "./BSidebarPage.vue?vue&type=template&id=32cb5f1c&scoped=true"
import script from "./BSidebarPage.vue?vue&type=script&lang=js"
export * from "./BSidebarPage.vue?vue&type=script&lang=js"
import style0 from "./BSidebarPage.vue?vue&type=style&index=0&id=32cb5f1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cb5f1c",
  null
  
)

export default component.exports